<template>
    <Tab
        class="betSlipTabs"
        tabStyle="tab-betSlip"
        v-bind:value="activeTab"
        v-bind:tabList="tabList"
        v-on:update:value="onTabValueUpdate"
    />
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import Tab from '@/components/common/Tab.vue';
    import type { ITabItem } from '@/interface/Tab';
    import { SingleModeBetSlipTab } from '@/interface/enum';
    import { i18n } from '@/libraries/i18n';

    const props = withDefaults(defineProps<{
        activeTab: SingleModeBetSlipTab;
        gaSizePrefix: string;
        isDisabled?: boolean;
    }>(), {
        isDisabled: false,
    });

    const emit = defineEmits<{
        switchTab: [tab: SingleModeBetSlipTab];
    }>();

    function onTabValueUpdate(value: string | number) {
        if (props.isDisabled) return;
        if (value !== SingleModeBetSlipTab.Single && value !== SingleModeBetSlipTab.Parlay) return;

        emit('switchTab', value);
    }

    const tabList = computed<ITabItem[]>(() => [
        {
            value: SingleModeBetSlipTab.Single,
            title: i18n.t('bet_slip_tab_single'),
            tabGA: `${props.gaSizePrefix}_Tab_Single`,
        },
        {
            value: SingleModeBetSlipTab.Parlay,
            title: i18n.t('bet_slip_tab_parlay'),
            tabGA: `${props.gaSizePrefix}_Tab_Parlay`,
        },
    ]);
</script>
